import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['button', 'content']
  static values = { expandOnDesktop: { default: true, type: Boolean } }

  connect() {
    if (!this.expandOnDesktopValue || window.innerWidth < 1024) return

    this.buttonTargets.forEach(button => (button.ariaExpanded = true))
    this.contentTargets.forEach(content => (content.hidden = false))
  }

  toggle(_event) {
    const expanded = this.buttonTarget.ariaExpanded === 'true'
    this.buttonTarget.ariaExpanded = !expanded
    this.contentTarget.hidden = expanded
  }
}
